import { render } from "./InvoiceWidget.vue?vue&type=template&id=0e0e164e&scoped=true"
import script from "./InvoiceWidget.vue?vue&type=script&lang=js"
export * from "./InvoiceWidget.vue?vue&type=script&lang=js"

import "./employee-attendance-widget.scss?vue&type=style&index=0&id=0e0e164e&lang=scss&scoped=true"

import exportComponent from "/srv/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e0e164e"]])

export default __exports__